export const GET_CITY_LIST_REQUEST = "GET_CITY_LIST_REQUEST"
export const GET_CITY_LIST_SUCCESS = "GET_CITY_LIST_SUCCESS"
export const GET_STATE_LIST_REQUEST = "GET_STATE_LIST_REQUEST"
export const GET_STATE_LIST_SUCCESS = "GET_STATE_LIST_SUCCESS"
export const GET_COUNTY_LIST_REQUEST = "GET_COUNTY_LIST_REQUEST"
export const GET_COUNTY_LIST_SUCCESS = "GET_COUNTY_LIST_SUCCESS"
export const GET_TERRITORY_LIST_REQUEST = "GET_TERRITORY_LIST_REQUEST"
export const GET_TERRITORY_LIST_SUCCESS = "GET_TERRITORY_LIST_SUCCESS"
